"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const react_1 = require("react");
const use_debounce_1 = require("use-debounce");
const MultiSelectComboBoxFilter_1 = __importDefault(require("./MultiSelectComboBoxFilter"));
const constants = __importStar(require("../../search/constants"));
const utils_1 = require("../../utils");
const ControlledMultiSelectCombobox = (props) => {
    const { id, value, searchable, editable, customComponents, handleSearchTermChange, handleSearchTermChangeDebounce, labelMode, disabled, disabledLabel, applyOn, placeholder, } = props;
    const [multiState, setMultiState] = (0, react_1.useState)(value);
    const [isExpanded, setIsExpanded] = (0, react_1.useState)(false);
    const [selectedIndex, setSelected] = (0, react_1.useState)(0);
    const [searchedTerm, setSearchTerm] = (0, react_1.useState)('');
    const [customOptions, setCustomOptions] = (0, react_1.useState)([]);
    const isSearchable = !!searchable;
    const isEditable = !!editable;
    const dontFilterOptions = isSearchable && (0, utils_1.isFunctionDefined)(handleSearchTermChange);
    const debouncedFiltering = (0, use_debounce_1.useDebouncedCallback)((term) => {
        if (handleSearchTermChange && (0, utils_1.isFunctionDefined)(handleSearchTermChange)) {
            handleSearchTermChange(term, id);
        }
    }, handleSearchTermChangeDebounce || 1000);
    const configOptions = (0, react_1.useMemo)(() => props.options.map(o => ({
        key: o[constants.GuiOptionKey],
        label: o[constants.GuiOptionLabel] || o[constants.GuiOptionKey],
        group: o[constants.GuiOptionGroup] || '',
        customID: o[constants.CustomID],
        checked: multiState.includes(o[constants.GuiOptionKey]),
        disabled: !!o[constants.GuiDisabled],
    })), [props.options, multiState]);
    (0, react_1.useEffect)(() => {
        setMultiState(value);
    }, [value]);
    const addedOptions = (0, react_1.useMemo)(() => customOptions.map(o => ({
        key: o,
        label: o,
        group: 'Added Options',
        checked: true,
        disabled: false,
    })), [customOptions]);
    const options = (0, react_1.useMemo)(() => [...configOptions, ...addedOptions], [configOptions, addedOptions]);
    const selectedOptions = (0, react_1.useMemo)(() => options.filter((o) => o.checked), [options]);
    const filteredOptions = (0, react_1.useMemo)(() => options.filter(o => o.label.toLowerCase().includes(searchedTerm.toLowerCase()) || searchedTerm === ''), [options, searchedTerm]);
    const label = (0, react_1.useMemo)(() => {
        switch (selectedOptions.length) {
            case 0:
                return placeholder || `Any ${props.labelSingular || ''}`.trim();
            case 1:
                return selectedOptions.map(_ => _.label).toString();
            default:
                return `${selectedOptions.length} ${props.labelPlural || ''}`.trim();
        }
    }, [selectedOptions, props.labelPlural, props.labelSingular]);
    const handleCheckboxChange = (key, checked) => {
        setMultiState(values => (checked ? [...values, key] : values.filter(opt => opt !== key)));
        if (configOptions.filter(o => o.key === key).length === 0) {
            setCustomOptions(values => (checked ? [...values, key] : values.filter(opt => opt !== key)));
        }
        if (applyOn === 'change') {
            props.handleCheckboxChange(checked ? [...multiState, key] : multiState.filter(opt => opt !== key));
        }
    };
    const handlePillRemoval = (key) => {
        setMultiState(values => values.filter(opt => opt !== key));
        setCustomOptions(values => values.filter(opt => opt !== key));
        if (!isExpanded || applyOn === 'change') {
            props.handleCheckboxChange(multiState.filter(opt => opt !== key));
        }
    };
    const handleApply = () => {
        setSelected(-1);
        setIsExpanded(false);
        props.handleCheckboxChange(selectedOptions.map(o => o.key));
        if (!dontFilterOptions) {
            setSearchTerm('');
        }
    };
    const handleCancel = () => {
        setMultiState(value);
    };
    const handleClear = () => {
        setMultiState(selectedOptions.filter(o => o.disabled).map(o => o.key));
    };
    const handleToggle = () => {
        setIsExpanded(!isExpanded);
        setSelected(-1);
        if (!dontFilterOptions) {
            setSearchTerm('');
        }
    };
    const handleSelected = (selected) => {
        setSelected(validateSelected(selected));
    };
    const handleSearchTerm = (term) => {
        setSearchTerm(term);
        debouncedFiltering(term);
    };
    const handleSearchEnter = () => {
        const changedOptions = [];
        if (editable) {
            if (options.filter(o => o.label.toLowerCase() === searchedTerm.toLowerCase()).length === 0) {
                setCustomOptions(oldArray => [...oldArray, searchedTerm.toLowerCase()]);
                changedOptions.push(searchedTerm.toLowerCase());
            }
            setSearchTerm('');
        }
        if (configOptions.filter(o => o.label.toLowerCase() === searchedTerm.toLowerCase()).length === 1) {
            setMultiState(oldArray => [
                ...oldArray,
                ...configOptions.filter(o => o.label.toLowerCase() === searchedTerm.toLowerCase()).map(o => o.key),
            ]);
        }
        if (applyOn === 'change') {
            props.handleCheckboxChange([
                ...selectedOptions.map(o => o.key),
                ...configOptions.filter(o => o.label.toLowerCase() === searchedTerm.toLowerCase()).map(o => o.key),
                ...changedOptions,
            ]);
        }
    };
    const validateSelected = (selected) => {
        switch (true) {
            case selected >= options.length - 1:
                return options.length - 1;
            case selected <= -1:
                return -1;
            default:
                return selected;
        }
    };
    const filterLabelMode = labelMode || 'label';
    const disabledFilterLabel = disabledLabel || '';
    return (React.createElement(MultiSelectComboBoxFilter_1.default, { id: id, options: filteredOptions, selectedOptions: selectedOptions, filterLabel: label, disabledFilterLabel: disabledFilterLabel, filterLabelMode: filterLabelMode, searchable: isSearchable, editable: isEditable, expanded: isExpanded, selectedIndex: selectedIndex, handleCheckBoxChange: handleCheckboxChange, handlePillRemoval: handlePillRemoval, handleExpandChange: setIsExpanded, handleToggle: handleToggle, handleApply: handleApply, handleClear: handleClear, handleCancel: handleCancel, handleSelected: handleSelected, handleSearchTerm: handleSearchTerm, handleSearchEnter: handleSearchEnter, searchTerm: searchedTerm, values: value, customComponents: customComponents, disabled: disabled, applyOn: applyOn }));
};
exports.default = ControlledMultiSelectCombobox;
